module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="modal-dialog modal-lg" role="document">\r\n    <div class="modal-content">\r\n      <div class="modal-header">\r\n        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>\r\n        <h2 class="modal-title" id="myModalLabel">'+
((__t=(lang.HISTORICO))==null?'':_.escape(__t))+
'</h2>\r\n      </div>\r\n      <div class="modal-body">\r\n        <form id="goods">\r\n        <div class="tab-pane active">\r\n            <div class="form-group col-sm-3 col-xs-2">\r\n                <label for="id">'+
((__t=(lang.CODIGO))==null?'':_.escape(__t))+
':</label>\r\n                <input type="number" value="'+
((__t=(attributes.itemId))==null?'':_.escape(__t))+
'" id="id" class="form-control" disabled/>\r\n            </div>\r\n            <div class="form-group col-sm-3 col-xs-2">\r\n                <label for="ref">'+
((__t=(lang.REF_INTERNA))==null?'':_.escape(__t))+
':</label>\r\n                <input type="text" value="'+
((__t=(attributes.ref))==null?'':_.escape(__t))+
'" id="ref" class="form-control" disabled/>\r\n            </div>\r\n            <div class="form-group col-sm-3 col-xs-2">\r\n                <label class="control-label" for="fechaAlta">'+
((__t=(lang.FECHA_ALTA))==null?'':_.escape(__t))+
':</label>\r\n                <input type=\'text\' id="fechaAlta" name="start" class="form-control date" value="'+
((__t=(attributes.fechaAlta))==null?'':_.escape(__t))+
'" disabled/> \r\n            </div>\r\n            <div class="form-group col-sm-3 col-xs-2">\r\n                <label class="control-label" for="fechaBaja" >'+
((__t=(lang.FECHA_BAJA))==null?'':_.escape(__t))+
':</label>\r\n                <input type=\'text\' id="fechaBaja" name="start" class="form-control date" value="'+
((__t=(attributes.fechaBaja))==null?'':_.escape(__t))+
'" disabled/> \r\n            </div>            \r\n            <div class="form-group col-xs-12">\r\n                <label for="epigraph">'+
((__t=(lang.EPIGRAFE))==null?'':_.escape(__t))+
':</label>\r\n                <input type=\'text\' id="epigraph" name="start" class="form-control date" value="'+
((__t=(lang[attributes.epigraph]))==null?'':_.escape(__t))+
'" disabled/> \r\n            </div>\r\n\r\n        </div>\r\n        </form>\r\n        <br/>\r\n        <h3>'+
((__t=(lang.LIST_CHANGES))==null?'':_.escape(__t))+
'</h3>\r\n        <table id="listsDataLogs" class="table-striped table-bordered">\r\n        ';

            _.each(logData, function(l){
                if(!l.operacion && !l.fecha_modificado)
                    return;

                print('<thead>');
                print('<tr><th colspan="2">' + l.operacion + ' -- ' + l.fecha_modificado + '</th></tr>');
                print('</thead>');
                if(l.source){
                    print('<tbody>');
                    var source  = l.source;
                    for(var s in source){
                        if(!source[s] || source[s]==="")
                            continue;

                        if(typeof source[s] === "object"){
                            for(var sub in source[s]){
                                if(!source[s][sub] || source[s][sub] === "")
                                    continue;

                                if(typeof source[s][sub] === "object"){
                                    var i = 0;
                                    for(var m in source[s][sub]){
                                        var master = source[s][sub][m];
                                        print('<tr><td>' + lang[m.toUpperCase()] + ' [' + i + ']</td><td>' + master + '</td></tr>');        
                                    }
                                    i++;
                                }else
                                    print('<tr><td>' + lang[sub.toUpperCase()] + '</td><td>' + source[s][sub] + '</td></tr>');    
                            }
                        }else
                            print('<tr><td>' + lang[s.toUpperCase()] + '</td><td>' + source[s] + '</td></tr>');
                    }
                    print('</tbody>');
                }
            });
        
__p+='\r\n        </table>\r\n        <div class="modal-footer">\r\n        <div class="col-xs-12"> \r\n            <button type="reset" class="btn btn-danger" id="cancel">'+
((__t=(lang.CANCELAR))==null?'':_.escape(__t))+
'</button>\r\n        </div>\r\n    </div>\r\n   </div>\r\n</div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/views/logs/logsViewDetail.ejs
// module id = 430
// module chunks = 0